	export enum LicensePlanTypeEnum {
		Audiology = 1,
		Dispensing = 2,
		Both = 3
	}
